import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Table } from 'components';
import { Header } from 'semantic-ui-react';

// eslint-disable-next-line react/prefer-stateless-function
export default class Holdings extends Component {
  render() {
    const { data } = this.props;
    const holdings = [...data.top_holdings].sort(
      (holdingA, holdingB) => holdingB.weight - holdingA.weight
    );

    const split = data.holdings_date ? data.holdings_date.split('-') : null;
    const months = {
      '01': 'January',
      '02': 'February',
      '03': 'March',
      '04': 'April',
      '05': 'May',
      '06': 'June',
      '07': 'July',
      '08': 'August',
      '09': 'September',
      10: 'October',
      11: 'November',
      12: 'December',
    };
    const date = split
      ? `As of ${months[split[1]]} ${split[2]}, ${split[0]}`
      : 'N/A';

    return (
      <div>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          {' '}
          <p
            style={{
              fontSize: '1rem',
              color: 'rgba(0, 0, 0, 0.6)',
              marginTop: '3rem',
              textAlign: 'center',
            }}
          >
            For funds with a fund-of-funds (FOF) structure, we may show the top
            10 holdings of the underlying funds.
          </p>
        </div>
        <Header
          size="medium"
          style={{ margin: '2rem 0 0 0', textAlign: 'left' }}
        >
          <Header.Content style={{ textAlign: 'left' }}>
            Snapshot Date&nbsp;
          </Header.Content>
          <Header.Subheader>{date}</Header.Subheader>
        </Header>

        <Table textAlign="center" style={{ margin: '1rem 0 0 0' }}>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Ticker</Table.HeaderCell>

              <Table.HeaderCell>Security name</Table.HeaderCell>
              <Table.HeaderCell>Weight</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {holdings.map(({ ticker, name, weight }, index) => (
              <Table.Row key={`${ticker}-${name}-${index}`}>
                <Table.Cell>{ticker || '-'}</Table.Cell>
                <Table.Cell>{name}</Table.Cell>
                <Table.Cell>{weight}%</Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      </div>
    );
  }
}

Holdings.propTypes = {
  data: PropTypes.object.isRequired,
};
